import React from 'react';
import { connect } from 'react-redux';
import storeManager from '../../store/StoreManager';
import { ScrollableComponent } from '../menus/ScrollableComponent';
import { ClipartSelectorButton } from '../menus/ClipartSelectorButton';
import { ClipartSelectorButtonExpanded } from '../menus/ClipartSelectorButtonExpanded';
import appParameters from '../../components/utils/AppParameters'
import masterUniverseUtils from '../../components/utils/MasterUniverseUtils';
import properties from '../../constants/Properties';
import mouseUtils from '../../components/utils/MouseUtils';
import platformDetection from '../../components/utils/PlatformDetection';
import hoverManager from '../utils/HoverManager';
import localesManager from '../../locales/LocalesManager';

const ClipartSelectorListContent = React.createClass({
    getInitialState() {
        return {
            isOver: false,
            videoElements: []
        };
    },
    componentDidMount() {
        this.initElements();
    },
    initElements() {
        var videoElements = this.getElements();

        this.setState({
            videoElements
        });
    },
    getElements() {
        var items = masterUniverseUtils.getCurrentVideoThemes();
        var item;
        var elements = [];
        var i;
        const listType = this.getListStyle();
        var isVideoTag = 'isVideo';

        for (i=0; i<items.length; i++) {
            item = items[i];

            if (listType == 'collapsed')
                elements.push(<ClipartSelectorButton href={items[i].href} dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} index={i} value={item}  key={'clipartSelector' + isVideoTag + i}/>);
            else
                elements.push(<ClipartSelectorButtonExpanded href={items[i].href} dispatch={this.props.dispatch} accordionWidth={this.props.accordionWidth} index={i} value={item}  key={'clipartSelector' + isVideoTag + i}/>);
        }

        return elements;
    },
    onMouseIn() {
        const listStyle = this.getListStyle();

        if (listStyle == 'collapsed')
            hoverManager.show(this.refs.listView, 'expandedListView', 'left');
        else
            hoverManager.show(this.refs.listView, 'collapsedListView', 'left');

        this.setState({
            isOver: true
        });
    },
    getButtonLabel() {
        if (this.getListStyle() == 'collapsed')
            localesManager.getCaption('expandedListView', 'hover');
        else
            localesManager.getCaption('collapsedListView', 'hover');
    },
    onMouseOut() {
        hoverManager.hide();

        this.setState({
            isOver: false
        });
    },
    onChangeListStyle(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const listStyle = this.getListStyle();

        if (platformDetection.isIOS()) {
            if (listStyle == 'collapsed')
                sessionStorage.setItem('listStyle', 'exapanded');
            else
                sessionStorage.setItem('listStyle', 'collapsed');
        } else {
            if (listStyle == 'collapsed')
                localStorage.setItem('listStyle', 'exapanded');
            else
                localStorage.setItem('listStyle', 'collapsed');
        }

        setTimeout(this.refreshView, 10);
    },
    getListStyle() {
        var listStyle;

        if (platformDetection.isIOS())
            listStyle = sessionStorage.getItem('listStyle');
        else
            listStyle = localStorage.getItem('listStyle');

        if (listStyle == 'collapsed')
            return 'collapsed';
        else
            return 'exapanded';
    },
    refreshView() {
        this.initElements();
        this.forceUpdate();
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.videoElements != nextState.videoElements || this.state.isOver != nextState.isOver || this.props.isUniversesVisible != newProps.isUniversesVisible || this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        if (this.props.isUniversesVisible == false || this.state == undefined || this.state.videoElements == undefined)
            return (<div/>);

        const topPadding = 33;
        const bottomPadding = 10;

        const listStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_COLOR,
            width: this.props.accordionWidth,
            height: this.props.windowHeight - 2 * properties.CLIPART_BUTTON_HEIGHT,
            top: 2 * properties.CLIPART_BUTTON_HEIGHT,
            left: 0,
            overflowX: 'hidden',
            overflowY: 'hidden'
        };

        const listType = this.getListStyle();
        var itemHeight;

        if (listType == 'collapsed')
            itemHeight = properties.UNIVERSE_BUTTON_HEIGHT;
        else {
            const scrollWidth = 15;
            const hGap = 10;
            const bottomGap = 14;
            const textHeight = 17;
            const buttonWidth = this.props.accordionWidth - 2 * hGap - scrollWidth;
            itemHeight = buttonWidth * 9 / 16 + textHeight + bottomGap;
        }

        var elements = this.state.videoElements;

        var componentProperties = {};
        componentProperties.paddingTop = 0;
        componentProperties.paddingLeft = 0;
        componentProperties.width = this.props.accordionWidth;
        componentProperties.height = this.props.windowHeight - 2 * properties.CLIPART_BUTTON_HEIGHT - topPadding - bottomPadding;
        componentProperties.top = topPadding;
        componentProperties.displayState = 'block';
        componentProperties.scrollHeight = elements.length * itemHeight;
        componentProperties.elements = elements;
        componentProperties.backgroundColor = properties.BROWSER_COLOR;

        var iconSrc;

        if (listType == 'collapsed') {
            if (this.state.isOver == true) {
                iconSrc = appParameters.RESOURCES_LOCATION() + 'assets/collapseListHover.png';
            } else {
                iconSrc = appParameters.RESOURCES_LOCATION() + 'assets/collapseList.png';
            }
        } else {
            if (this.state.isOver == true) {
                iconSrc = appParameters.RESOURCES_LOCATION() + 'assets/expandListHover.png';
            } else {
                iconSrc = appParameters.RESOURCES_LOCATION() + 'assets/expandList.png';
            }
        }

        const iconButtonStyle = {
            position: 'absolute',
            top: 7,
            right: 25,
            width: 35,
            height: 35 * 26/46,
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            textAlign: 'left',
            borderStyle: 'none',
            background: 'none',
            display: 'flex'
        };

        const iconStyle = {
            position: 'absolute',
            top: 0,
            right: 0,
            width: 35,
            height: 35 * 26/46
        };

        var expandCollpaseButton;

        // expandCollpaseButton =
        //     <button aria-label={this.getButtonLabel()} style={iconButtonStyle} ref='listView' onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut} onTouchEnd={this.onChangeListStyle} onClick={this.onChangeListStyle}>
        //         <img alt='' aria-hidden='true' style={iconStyle} src={iconSrc}/>
        //     </button>;

        return (
            <div style={listStyle}>
                {expandCollpaseButton}

                <ScrollableComponent componentProperties={componentProperties}/>
            </div>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    var accordionWidth = state.accordion.width;

    if (accordionWidth == undefined)
        accordionWidth = properties.BROWSER_WIDTH;

    return {
        accordionWidth
    };
}

export const ClipartSelectorList = connect(mapStateToProps)(ClipartSelectorListContent);



/** WEBPACK FOOTER **
 ** ./src/components/menus/ClipartSelectorList.js
 **/